export default (theme) => ({
    root: {
        height: 20,
        minWidth: 70,
        padding: '2px 8px',
        boxSizing: 'border-box',
        border: '1px solid transparent',
        borderRadius: 4,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    Text: {
        display: 'inline-block',
        textAlign: 'center',
    },
    // Types
    default: {
        backgroundColor: theme.colors.grey[100],
        '& $Text': {
            color: theme.colors.textLight.secondary,
        },
    },
    outlined: {
        backgroundColor: theme.colors.primary.white,
        borderColor: theme.colors.primary.black,
        color: theme.colors.primary.black,
    },
    actionMinor: {
        backgroundColor: theme.colors.actionMinor[100],
        '& $Text': {
            color: theme.colors.actionMinor[500],
        },
    },
    semanticPositive: {
        backgroundColor: theme.colors.semantic.positiveCustom100,
        '& $Text': {
            color: theme.colors.semantic.positive500,
        },
    },
    semanticFocus: {
        backgroundColor: theme.colors.semantic.focusCustom100,
        '& $Text': {
            color: theme.colors.semantic.focus500,
        },
    },
    semanticNegative: {
        backgroundColor: theme.colors.semantic.negativeCustom100,
        '& $Text': {
            color: theme.colors.semantic.negative500,
        },
    },
    semanticInfo: {
        backgroundColor: theme.colors.semantic.infoCustom50,
        '& $Text': {
            color: theme.colors.semantic.info400,
        },
    },
    caution: {
        backgroundColor: theme.colors.semantic.caution100,
        '& $Text': {
            color: theme.colors.semantic.caution500,
        },
    },
    ongoing: {
        backgroundColor: theme.colors.temp.purple100,
        '& $Text': {
            color: theme.colors.temp.purple500,
        },
    },
    promotion: {
        backgroundColor: theme.colors.background.jadeT7,
        '& $Text': {
            color: theme.colors.textLight.jadeAccessible,
        },
    },
    // For retrocompatibility
    error: {
        extend: 'semanticNegative',
    },
    success: {
        extend: 'semanticPositive',
    },
    info: {
        extend: 'semanticInfo',
    },
    warning: {
        extend: 'semanticFocus',
    },
    inverted: {
        '& $Text': {
            color: theme.colors.primary.white,
        },
        '&$default': {
            backgroundColor: theme.colors.grey[500],
        },
        '&$outlined': {
            backgroundColor: theme.colors.primary.black,
            borderColor: theme.colors.primary.black,
            color: theme.colors.primary.white,
        },
        '&$actionMinor': {
            backgroundColor: theme.colors.actionMinor[500],
        },
        '&$semanticPositive': {
            backgroundColor: theme.colors.semantic.positive400,
        },
        '&$success': {
            backgroundColor: theme.colors.semantic.positive400,
        },
        '&$semanticFocus': {
            backgroundColor: theme.colors.semantic.focusCustom400,
        },
        '&$warning': {
            backgroundColor: theme.colors.semantic.focusCustom400,
        },
        '&$semanticNegative': {
            backgroundColor: theme.colors.semantic.negative450,
        },
        '&$error': {
            backgroundColor: theme.colors.semantic.negative450,
        },
        '&$semanticInfo': {
            backgroundColor: theme.colors.semantic.info400,
        },
        '&$info': {
            backgroundColor: theme.colors.semantic.info400,
        },
        '&$caution': {
            backgroundColor: theme.colors.semantic.caution500,
        },
        '&$ongoing': {
            backgroundColor: theme.colors.temp.purple400,
        },
        '&$promotion': {
            backgroundColor: theme.colors.actionMajor[350],
            '& $Text': {
                color: theme.colors.textDark.primary,
            },
        },
        '&$hasHover:hover, &$isActive': {
            backgroundColor: theme.colors.grey[600],
        },
        '&$semanticPositive$hasHover:hover, &$semanticPositive$isActive': {
            backgroundColor: theme.colors.semantic.positive500,
        },
        '&$success$hasHover:hover, &$success$isActive': {
            backgroundColor: theme.colors.semantic.positive500,
        },
        '&$semanticFocus$hasHover:hover, &$semanticFocus$isActive': {
            backgroundColor: theme.colors.semantic.focus500,
        },
        '&$warning$hasHover:hover, &$warning$isActive': {
            backgroundColor: theme.colors.semantic.focus500,
        },
        '&$semanticNegative$hasHover:hover, &$semanticNegative$isActive': {
            backgroundColor: theme.colors.semantic.negative500,
        },
        '&$error$hasHover:hover, &$error$isActive': {
            backgroundColor: theme.colors.semantic.negative500,
        },
        '&$semanticInfo$hasHover:hover, &$semanticInfo$isActive': {
            backgroundColor: theme.colors.semantic.info500,
        },
        '&$info$hasHover:hover, &$info$isActive': {
            backgroundColor: theme.colors.semantic.info500,
        },
        '&$caution$hasHover:hover, &$caution$isActive': {
            backgroundColor: theme.colors.semantic.caution600,
        },
        '&$actionMinor$hasHover:hover, &$actionMinor$isActive': {
            backgroundColor: theme.colors.actionMinor[600],
        },
        '&$ongoing$hasHover:hover, &$ongoing$isActive': {
            backgroundColor: theme.colors.temp.purple500,
        },
        '&$promotion$hasHover:hover, &$promotion$isActive': {
            backgroundColor: theme.colors.actionMajor[450],
        },
    },
    hasHover: {
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.colors.grey[200],
        },
        '&$outlined:hover': {
            backgroundColor: theme.colors.grey[200],
        },
        '&$semanticPositive:hover': {
            backgroundColor: theme.colors.semantic.positiveCustom200,
        },
        '&$semanticFocus:hover': {
            backgroundColor: theme.colors.semantic.focusCustom200,
        },
        '&$semanticNegative:hover': {
            backgroundColor: theme.colors.semantic.negativeCustom200,
        },
        '&$semanticInfo:hover': {
            backgroundColor: theme.colors.semantic.infoCustom100,
        },
        '&$caution:hover': {
            backgroundColor: theme.colors.semantic.caution200,
        },
        '&$actionMinor:hover': {
            backgroundColor: theme.colors.actionMinor[200],
        },
        '&$ongoing:hover': {
            backgroundColor: theme.colors.temp.purple200,
        },
        '&$promotion:hover': {
            backgroundColor: theme.colors.semantic.positiveCustom200,
        },
        '&$success:hover': {
            backgroundColor: theme.colors.semantic.positiveCustom200,
        },
        '&$error:hover': {
            backgroundColor: theme.colors.semantic.negativeCustom200,
        },
        '&$info:hover': {
            backgroundColor: theme.colors.semantic.infoCustom100,
        },
        '&$warning:hover': {
            backgroundColor: theme.colors.semantic.focusCustom200,
        },
    },
    isActive: {
        backgroundColor: theme.colors.grey[200],
        '&$outlined': {
            backgroundColor: theme.colors.primary.white,
        },
        '&$semanticPositive': {
            backgroundColor: theme.colors.semantic.positiveCustom200,
        },
        '&$semanticFocus': {
            backgroundColor: theme.colors.semantic.focusCustom200,
        },
        '&$semanticNegative': {
            backgroundColor: theme.colors.semantic.negativeCustom200,
        },
        '&$semanticInfo': {
            backgroundColor: theme.colors.semantic.infoCustom100,
        },
        '&$caution': {
            backgroundColor: theme.colors.semantic.caution200,
        },
        '&$actionMinor': {
            backgroundColor: theme.colors.actionMinor[200],
        },
        '&$ongoing': {
            backgroundColor: theme.colors.temp.purple200,
        },
        '&$promotion': {
            backgroundColor: theme.colors.semantic.positiveCustom200,
        },
        '&$success': {
            backgroundColor: theme.colors.semantic.positiveCustom200,
        },
        '&$error': {
            backgroundColor: theme.colors.semantic.negativeCustom200,
        },
        '&$info': {
            backgroundColor: theme.colors.semantic.infoCustom100,
        },
        '&$warning': {
            backgroundColor: theme.colors.semantic.focusCustom200,
        },
    },
});
